import { render, staticRenderFns } from "./IsolationLog.vue?vue&type=template&id=0ac35a60"
import script from "./IsolationLog.vue?vue&type=script&lang=js"
export * from "./IsolationLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports